let lastScrollY = 0;
let ticking = false;
let hasScrolledPastMid = false;  // Flag to track if user has scrolled past mid-page

const topThreshold = 100;  // Button appears after scrolling past this (from top)
const midThreshold = 500;  // Button disappears after scrolling past this (mid-page)

// Function to check if the side menu is open
function isMenuOpen() {
  const menu = document.getElementById("side-menu");  // Replace with your menu's ID or selector
  return menu && menu.classList.contains("open");  // Assumes menu has "open" class when active
}

window.addEventListener("scroll", () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      const currentScrollY = window.scrollY;
      
      const backBtn = document.querySelector(".back-button");
      
      // Update flag if scrolled past mid-threshold
      if (currentScrollY > midThreshold) {
        hasScrolledPastMid = true;
      }
      
      // Show/hide logic:
      // - Only show if menu is NOT open AND other conditions are met
      if (!isMenuOpen() && (
          (currentScrollY > topThreshold && !hasScrolledPastMid) || 
          (currentScrollY < topThreshold && hasScrolledPastMid)
        )) {
        backBtn.classList.add("visible");
      } else {
        backBtn.classList.remove("visible");
      }
      
      lastScrollY = currentScrollY;
      ticking = false;
    });
    ticking = true;
  }
});